// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Jsps","resendInfoText":"OnGoingPaymentBox_resendInfoText__2rlRE"};